<mat-form-field>
  <mat-label>{{ api.name }} models</mat-label>
  <mat-select [(value)]="selectedValue" (selectionChange)="onSelectChange($event)">
    <mat-option *ngFor="let model of models" [value]="model.id">
      {{ model.displayName ? model.displayName : model.id }}
    </mat-option>
  </mat-select>
</mat-form-field>
